<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="agentId">{{ agentName }} 的用户</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      @selection-change="handleSelectionChange"
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="password" label="用户密码" width="300">
      </el-table-column>


      <el-table-column sortable prop="endTime" label="用户到期时间" width="300">
        <template slot-scope="scope">{{ fmtEnd(scope.row.endTime) }}</template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="560">
        <template slot-scope="scope">
          <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" @click="extend(scope.row, 1)">+1天</el-button>
          <el-button size="mini" @click="extend(scope.row, 30)">+30天</el-button>
          <el-button size="mini" @click="extend(scope.row, 180)">+180天</el-button>
          <el-button size="mini" @click="extend(scope.row, 365)">+365天</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="用户密码" prop="password">
          <el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="用户密码"></el-input>
        </el-form-item>
        <el-form-item label="到期日期" prop="endTime">
          <el-date-picker v-model="editForm.endTime" type="date" value-format="timestamp" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { userDel, userList, userSave, userUpdate, userBatchDel, userExtend } from '../../api/campsMG'
import { agentUsersList } from '../../api/agentMG'
import {
  RoleRightSave
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
      selectedRows: [], // 多选选中的用户
      editMode: 'add', // add | edit
      oldPassword: '', // 编辑时的原密码
      editForm: {
        id: '',
        nickname: '',
        password:'',
        endTime:''
      },
      // rules 表单验证
      rules: {
        password: [
          { required: true, message: '请输入用户密码', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择到期日期', trigger: 'change' }
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  computed: {
    // 代理名下用户子列表时，路由 query 带 agentId；普通用户列表为空
    agentId() {
      return this.$route.query.agentId || ''
    },
    agentName() {
      return this.$route.query.name || ''
    }
  },

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    getImagePath(filename) {
      return filename; // 拼接完整的图片路径
    },
    // 获取用户列表（带 agentId 时只取该代理开出的用户）
    getdata(parameter) {
      this.loading = true
      if (this.agentId) {
        agentUsersList({
          agentId: this.agentId,
          page: this.pageparm.currentPage,
          pageSize: this.pageparm.pageSize
        })
          .then(r => {
            this.loading = false
            if (r.code != 0) {
              this.$message({ type: 'info', message: r.msg })
            } else {
              this.listData = r.data.list
              this.pageparm.total = r.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取用户列表失败，请稍后再试！')
          })
        return
      }
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      userList(this.pageparm)
        .then(res => {
          this.loading = false
          if (res.data.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取角色列表失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.pageparm.currentPage = this.formInline.page
      this.pageparm.pageSize = this.formInline.limit
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          const request = this.editMode === 'edit'
            ? userUpdate({
              oldPassword: this.oldPassword,
              newPassword: this.editForm.password,
              endTime: this.editForm.endTime
            })
            : userSave(this.editForm)
          request
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    //显示添加界面
    handleEdit: function () {
      this.editMode = 'add'
      this.oldPassword = ''
      this.editFormVisible = true
      this.title = '添加'
      this.editForm.endTime = ''
      this.editForm.password = ''
    },
    // 显示编辑界面（回显密码与到期时间）
    openEdit(row) {
      this.editMode = 'edit'
      this.oldPassword = row.password
      this.editFormVisible = true
      this.title = '编辑'
      this.editForm.password = row.password
      this.editForm.endTime = this.dateStrToTs(row.endTime)
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.clearValidate()
      })
    },
    // "yyyy-MM-dd[ HH:mm:ss]" -> 当日0点时间戳；已是数字则原样返回
    dateStrToTs(v) {
      if (v === null || v === undefined || v === '') return ''
      if (typeof v === 'number') return v
      // 只取日期部分，避免后端返回 "yyyy-MM-dd HH:mm:ss" 时拼接出非法字符串
      let s = String(v).trim()
      const sp = s.search(/[ T]/)
      if (sp >= 0) s = s.slice(0, sp)
      const d = new Date(s.replace(/-/g, '/') + ' 00:00:00')
      return isNaN(d.getTime()) ? '' : d.getTime()
    },
    // 到期时间展示：兼容 ISO-8601（带时区）与 "yyyy-MM-dd"，统一显示本地日期
    fmtEnd(v) {
      if (v === null || v === undefined || v === '') return ''
      const s = String(v).trim()
      let d
      if (s.indexOf('T') >= 0 || /[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) {
        d = new Date(s)
      } else {
        d = new Date(s.replace(/-/g, '/'))
      }
      if (isNaN(d.getTime())) return s
      const p = n => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    },
    // 多选变化
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },
    // 多选批量删除（连带清理关联数据）
    batchDelete() {
      if (!this.selectedRows.length) {
        this.$message({ type: 'warning', message: '请先勾选要删除的用户' })
        return
      }
      this.$confirm('已选 ' + this.selectedRows.length + ' 个用户，将连同其名下科目/客户等全部关联数据一并删除，确定吗?', '批量删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const passwords = this.selectedRows.map(r => r.password).join(',')
          userBatchDel({ passwords })
            .then(res => {
              if (res.code == 0) {
                this.$message({ type: 'success', message: '已删除 ' + (res.data && res.data.count != null ? res.data.count : this.selectedRows.length) + ' 个用户！' })
                this.getdata(this.formInline)
              } else {
                this.$message({ type: 'info', message: res.msg })
              }
            })
            .catch(() => {
              this.$message.error('批量删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },
    // 延长到期时间：必须二次确认，弹窗中明确显示该行用户密码等信息，防止误操作
    extend(row, days) {
      const h = this.$createElement
      const msg = h('div', { style: 'line-height:1.9;font-size:14px' }, [
        h('p', { style: 'margin:2px 0' }, [
          '用户密码：',
          h('b', { style: 'color:#f56c6c;font-size:15px' }, String(row.password))
        ]),
        h('p', { style: 'margin:2px 0' }, ['当前到期：', this.fmtEnd(row.endTime) || '—']),
        h('p', { style: 'margin:2px 0' }, ['延长天数：', h('b', { style: 'color:#67c23a' }, '+' + days + ' 天')])
      ])
      this.$confirm(msg, '延长到期时间确认', {
        confirmButtonText: '确认延长',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'extend-confirm-box',
        distinguishCancelAndClose: true
      })
        .then(() => {
          userExtend({ password: row.password, days })
            .then(res => {
              if (res.code == 0) {
                this.$message({ type: 'success', message: '已为用户【' + row.password + '】延长 ' + days + ' 天' })
                this.getdata(this.formInline)
              } else {
                this.$message({ type: 'info', message: res.msg })
              }
            })
            .catch(() => {
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(action => {
          if (action === 'cancel') {
            this.$message({ type: 'info', message: '已取消延长' })
          }
        })
    },
    // 删除角色
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userDel({ password: row.password })
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      this.checkmenu = change
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = []
      for (var i in list) {
        if (!temptree[list[i].id]) {
          var trow = {
            id: list[i].id,
            pId: list[i].pId,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: []
          }
          temptree[list[i].id] = trow
          items.push(trow)
        }
        if (list[i].uid > 0) {
          temptree[list[i].id]['children'].push({
            id: list[i].id,
            pId: list[i].pId,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: []
          })
        }
      }

      for (var j in items) {
        if (temptree[items[j].pId]) {
          temptree[items[j].pId]['children'].push(temptree[items[j].id])
        } else {
          tree.push(temptree[items[j].id])
        }
      }
      temptree = null
      items = null
      return tree
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        roleId: this.saveroleId,
        moduleIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id)
        }
        parm.moduleIds = JSON.stringify(moduleIds)
      }
      RoleRightSave(parm)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.menuAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

<style>
/* 延长确认 MessageBox（append-to-body，scoped 无法命中）：底部按钮整组居中 */
.extend-confirm-box .el-message-box__btns {
  text-align: center !important;
  padding-top: 4px;
}
.extend-confirm-box .el-message-box__btns .el-button {
  min-width: 96px;
}
.extend-confirm-box .el-message-box__btns .el-button + .el-button {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Role.vue